<form *ngIf="form" [formGroup]="form">
  <div class="row">
    <div class="col form-group">
      <label for="timeframeGroup" class="control-label">Timeframe</label>

      <div class="d-flex flex-row justify-content-between" id="timeframeGroup">
        <div class="w-100 mr-2">
          <frontend-dropdown
            elementId="days-timeframe"
            formControlName="number"
            [items]="days"
            bindLabel="name"
            bindValue="value"
          ></frontend-dropdown>
        </div>

        <common-radio-group
          [items]="periodRadioItems"
          formControlName="period"
          uncheckedButtonClass="btn-outline-success mb-0"
          checkedButtonClass="btn-success mb-0"
        ></common-radio-group>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col form-group d-flex flex-row align-items-center justify-content-between align-items-center mb-3">
      <div class="control-label mr-3">Since</div>

      <common-radio-group
        [items]="eventsRadioItems"
        [minButtonWidthPx]="110"
        formControlName="event"
        uncheckedButtonClass="btn-outline-success mb-0"
        checkedButtonClass="btn-success mb-0"
      ></common-radio-group>
    </div>
  </div>

  <div class="row">
    <div class="col form-group">
      <button
        type="submit"
        class="btn btn-info w-100"
        [style.min-width]="'110px'"
        [disabled]="submitting || form.invalid || !form.dirty"
        (click)="submit()"
      >Save changes</button>
    </div>

    <div class="col form-group">
      <button class="btn btn-danger mr-2 w-100" (click)="reset()">Cancel</button>
    </div>
  </div>
</form>
